import React from "react";
import { useNotificationsHook } from "./notifications-hooks";

type ContextNotifications = ReturnType<typeof useNotificationsHook>;
export const NotificationsContext =
  React.createContext<ContextNotifications | null>(null);

export function useContextNotifications() {
  const context = React.useContext(NotificationsContext);

  if (!context) {
    throw new Error(
      "useContextNotifications must be used within a ContextNotificationsProvider"
    );
  }

  return context;
}
